import styled from '@emotion/styled'
import { List } from '@material-ui/core'

const StyledList = styled(List)`
  height: 100%;
`

export { StyledList as List }
